import { Button, Input, notification, Typography } from "antd";
import { useState, useEffect } from "react";
import {
  usePhoneVerification,
  useCreatePhoneVerification,
  useSendPhoneVerification,
} from "../../api/PhoneVerification";

const { Search } = Input;

const PhoneVerification = ({ user }) => {
  const [submitting, setSubmitting] = useState(false);
  const [validationExists, setValidatationExists] = useState();
  const [validationCode, setValidationCode] = useState();

  const { isLoading, data } = usePhoneVerification(user?.UserId);
  const createVerification = useCreatePhoneVerification();
  const sendVerification = useSendPhoneVerification();

  useEffect(() => {
    if (data?.ValidationExists) {
      setValidatationExists(data.ValidationExists);
    }
  }, [data]);

  const create = () => {
    setSubmitting(true);
    createVerification
      .mutateAsync()
      .catch((error) => {
        console.log(error);
        notification.error({
          message: "Error",
          description: error.messge || error.response.data.message,
        });
      })
      .finally(() => setSubmitting(false));
  };

  const onSearch = async (value) => {
    if (value.length < 6) return;
    sendVerification
      .mutateAsync(value)
      .then((r) => {
        notification.success({
          message: "Success",
          description: "Phone number verified",
        });
      })
      .catch((error) => {
        console.log("Error with validation");
        notification.error({
          message: "Error",
          description: error.response.data,
        });
      });
  };
  return isLoading ? null : (
    <>
      {validationExists ? (
        <>
          <Search
            maxLength={6}
            minLength={6}
            value={validationCode}
            onChange={(e) => setValidationCode(e.target.value.toUpperCase())}
            enterButton="Verify"
            onSearch={onSearch}
            disabled={submitting}
          />
          <Typography.Text type="secondary">
            A verification code has been texted to the phone number provided
          </Typography.Text>
        </>
      ) : (
        <Button disabled={submitting} onClick={() => create()} size="small">
          Request Verification Code
        </Button>
      )}
    </>
  );
};

export default PhoneVerification;
